<template>
  <StageScaler>
    <BroadcastVideosStage
      ref="previewstage"
      data-testid="broadcast-videos-stage"
      :virtualBackground="virualBackgroundUrl"
      :logo="$store.getters['branding/theme_obj'].logo_url"
      :demoButtonText="$store.getters['branding/theme_obj'].demo_request_button_text"
      :showDemoLink="$store.getters['branding/theme_obj'].demo_link_enabled"
      :stageLogoSpec="{ url: logoUrl }"
      :showLowerThird="$store.state.branding.currentModuleId === 'lowerThirds'"
      :showSponsorLogo="$store.state.branding.currentModuleId === 'logos'"
      :showChatOnMobile="
        $store.state.branding.currentModuleId === 'sidebarColor' && $store.state.branding.currentView === 'cellphone'
      "
      :targets="$store.getters['branding/currentTargets']"
      :dropdownOpen="$store.state.branding.currentModuleId === 'agendaBackground'"
      :navigatorLinks="$store.getters['branding/navigatorLinks']"
      :stageChatTabs="$store.getters['branding/stageChatTabs']"
      :sidebarPrimaryTabs="$store.getters['branding/sidebarPrimaryTabs']"
      :showScreenSaver="$store.getters['branding/theme_obj'].onEditScreenSaver"
      :useNewNameCard="useNewNameCard"
    />
  </StageScaler>
</template>

<script>
import { BroadcastVideosStage } from '@goldcast/uicomponents-branding';

import StageScaler from './StageScaler.vue';

export default {
  name: 'BroadcastVideosStagePreview',
  components: { BroadcastVideosStage, StageScaler },
  props: {
    useNewNameCard: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    logoUrl() {
      const themeObj = this.$store.getters['branding/theme_obj'];
      const logos = themeObj?.logos || [];
      return this.$store.state.branding.currentModuleId === 'logos' ? logos[0] : '';
    },
    virualBackgroundUrl() {
      const themeObj = this.$store.getters['branding/theme_obj'];
      const bgList = themeObj?.virtual_backgrounds || [];
      return bgList[0] || '';
    }
  }
};
</script>
